import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getItem } from '../../../../utils/localStorage';
import { toastify } from '../../../../utils/toast';
import Layout from '../../component/layout'
import { makeRequest2 } from '../../../../utils/makeRequest';
import { createFAQ } from '../../../../utils/urls';

const AddFaq = () => {
    const navigate = useNavigate();

    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');

    const handleSubmit = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId')
            const faq = {question, answer}

            if(!faq.question)throw new Error('Question is required')
            if(!faq.answer)throw new Error('Answer is required')

            const response = await makeRequest2(createFAQ + '/' + facilityId, 'POST', faq)
            if(response.success){
                toastify('FAQ successfully added', 'success')
                setQuestion('')
                setAnswer('')
                navigate('/facility/visitor_access_management/faq')
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    }

    const handleClear = () =>{
        setQuestion('');
        setAnswer('');
    }


    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/app/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>FAQs</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Add FAQ</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <Link to={"#"} onClick={() => navigate(-1)}><span><i className="ti ti-arrow-narrow-left"></i> Back</span></Link>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add FAQs</h5>
                                </div>

                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-lg-12 col-xxl-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className='container'>
                                                        <div className='row'>
                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Question</label>
                                                                    <textarea
                                                                        className="form-control mb-3"
                                                                        rows="4"  // Adjust rows as needed
                                                                        value={question}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setQuestion(value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Answer</label>
                                                                    <textarea
                                                                        className="form-control mb-3"
                                                                        rows="4"  // Adjust rows as needed
                                                                        value={answer}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setAnswer(value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="text-end">
                                                        <button type="button" className="btn btn-outline-secondary" onClick={handleClear}>Clear</button>
                                                        &nbsp;
                                                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </Layout>
    )
}

export default AddFaq